// Validação e formatação de telefone, internacional.
//
// Vivia dentro de pages/users/UserForm.tsx e era a única validação de telefone
// do admin — proprietário e parceiro não validavam nada. Extraído para ser
// usado pelos três.
import i18n from '../i18n';

const BRAZIL_PHONE_REGEX = /^\+55 \d{2} 9\d{8}$/;
const INTL_PHONE_REGEX = /^\+\d{1,3} \d+$/;

export const PhoneUtils = {
  validatePhone: (phone: string): boolean => {
    if (!phone || !phone.trim()) return false;
    const cleanPhone = phone.replace(/\s+/g, ' ').trim();
    if (cleanPhone.startsWith('+55')) {
      return BRAZIL_PHONE_REGEX.test(cleanPhone);
    }
    return INTL_PHONE_REGEX.test(cleanPhone);
  },

  formatPhone: (value: string): string => {
    if (!value) return value;

    // Mantém apenas "+", dígitos e espaços; colapsa espaços múltiplos.
    const sanitized = value.replace(/[^\d+\s]/g, '').replace(/\s+/g, ' ');
    const cleaned = sanitized.replace(/\s+/g, '');

    // Conveniência de máscara para o Brasil (+55 XX 9XXXXXXXX).
    if (cleaned.startsWith('+55')) {
      const numbers = cleaned.substring(3);
      if (numbers.length === 0) return '+55';
      if (numbers.length <= 2) return '+55 ' + numbers;
      return '+55 ' + numbers.substring(0, 2) + ' ' + numbers.substring(2, 11);
    }

    // 11 dígitos puros → assume Brasil (atalho comum).
    if (/^\d{11}$/.test(cleaned)) {
      return '+55 ' + cleaned.substring(0, 2) + ' ' + cleaned.substring(2);
    }

    // Demais países: não força máscara — preserva o que o usuário digitou
    // (apenas "+", dígitos e espaços), deixando a validação decidir.
    return sanitized.trimStart();
  },

  getErrorMessage: (phone: string): string => {
    if (!phone || !phone.trim()) return i18n.t('users.phoneRequired');
    const cleanPhone = phone.replace(/\s+/g, ' ').trim();
    if (cleanPhone.startsWith('+55')) {
      return i18n.t('users.phoneFormatBrazil');
    }
    return i18n.t('users.phoneFormatInternational');
  },
};

export default PhoneUtils;
